export const dummyData = [
  {
    id: "S009",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "Stimuluz Technologies Limited",
    status: "Complete",
  },
  {
    id: "S008",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "Gavac Business Solutions",
    status: "Complete",
  },
  {
    id: "S007",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "MTN Ghana Limited",
    status: "Complete",
  },
  {
    id: "S005",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "Qodehub LLC",
    status: "Complete",
  },
  {
    id: "S004",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "Ramnet Solutions",
    status: "Complete",
  },
  {
    id: "S003",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "MPharma Limited",
    status: "Complete",
  },
  {
    id: "S002",
    created_at: "Jan 12, 2020 - 02:55pm",
    name: "Scancom Global LLC",
    status: "Complete",
  },
];
